import { parseNumbers } from 'helpers/utils'

export default () => ({
  expiry: null,
  remaining: null,
  size: 4,
  inputFields: [],

  init () {
    this.inputFields = Array(this.size).fill('')
    this.$watch('inputFields', (value) => {
      this.verificationCodeInputCompleted = !value.some((input) => input.value === '')
      this.verificationCode = this.inputFields.join('')

      value.forEach((item) => {
        if (item.length === this.size) { this.handleAutoFill(item) }
      })
    })
  },

  setFieldValue (index) {
    this.inputFields[index] = this.inputFields[index].substring(0, 1)
    this.setActiveField()
  },

  handleAutoFill (value) {
    this.inputFields = this.inputFields.map((_item, index) => value.split('')[index])
  },

  setActiveField () {
    const index = Number(document.activeElement.getAttribute('data-index'))
    const activeInput = this.$refs[`field${index}`]

    // Allow only numbers
    activeInput.value = parseNumbers(activeInput.value)
    activeInput.value = activeInput.value.replace(/[^0-9]/g, '')

    const isInputEmpty = this.$refs[`field${index}`].value === ''
    const isLastInput = index === this.size - 1
    const isFirstInput = index !== 0

    // Focus next input
    if (!isInputEmpty && !isLastInput) { this.$refs[`field${index + 1}`].focus() }

    // Focus previous input
    if (isInputEmpty && isFirstInput) { this.$refs[`field${index - 1}`].focus() }
  }
})
